export default __webpack_public_path__ + "9485a4c296ab216a69436afa8c79cdd7.svg";